/**
 * The product names on an order, for a table cell. The first two are shown and the rest are counted
 * ("+3 more", with every name in the tooltip), so an order of many products stays one short cell
 * without any product being dropped from view or from the count shown beside it.
 */
const SHOWN = 2;

export function ItemNames({ names }: { names: readonly string[] }) {
  if (names.length === 0) return <span className="mk-dim">—</span>;
  const rest = names.length - SHOWN;
  return (
    <div title={names.join('\n')}>
      {names.slice(0, SHOWN).map((n) => <div key={n}>{n}</div>)}
      {rest > 0 ? <div className="mk-dim">+{rest} more</div> : null}
    </div>
  );
}
